import { defineMessages } from 'react-intl';

export const lightBackgroundPaletteTooltipMessages: {
	'#4C9AFF': {
		defaultMessage: string;
		description: string;
		id: string;
	};
	'#57D9A3': {
		defaultMessage: string;
		description: string;
		id: string;
	};
	'#79E2F2': {
		defaultMessage: string;
		description: string;
		id: string;
	};
	'#97EDC9': {
		defaultMessage: string;
		description: string;
		id: string;
	};
	'#998DD9': {
		defaultMessage: string;
		description: string;
		id: string;
	};
	'#ABF5D1': {
		defaultMessage: string;
		description: string;
		id: string;
	};
	'#ADCBFB': {
		defaultMessage: string;
		description: string;
		id: string;
	};
	'#B1E4F7': {
		defaultMessage: string;
		description: string;
		id: string;
	};
	'#B3BAC5': {
		defaultMessage: string;
		description: string;
		id: string;
	};
	'#B3D4FF': {
		defaultMessage: string;
		description: string;
		id: string;
	};
	'#B3F5FF': {
		defaultMessage: string;
		description: string;
		id: string;
	};
	'#B7B9BE': {
		defaultMessage: string;
		description: string;
		id: string;
	};
	'#BDE97C': {
		defaultMessage: string;
		description: string;
		id: string;
	};
	'#C0B6F2': {
		defaultMessage: string;
		description: string;
		id: string;
	};
	'#D3F1A7': {
		defaultMessage: string;
		description: string;
		id: string;
	};
	'#DEEBFF': {
		defaultMessage: string;
		description: string;
		id: string;
	};
	'#E3BDFA': {
		defaultMessage: string;
		description: string;
		id: string;
	};
	'#E3FCEF': {
		defaultMessage: string;
		description: string;
		id: string;
	};
	'#E6FCFF': {
		defaultMessage: string;
		description: string;
		id: string;
	};
	'#EAE6FF': {
		defaultMessage: string;
		description: string;
		id: string;
	};
	'#EFDD4E': {
		defaultMessage: string;
		description: string;
		id: string;
	};
	'#EFFFD6': {
		defaultMessage: string;
		description: string;
		id: string;
	};
	'#F4F5F7': {
		defaultMessage: string;
		description: string;
		id: string;
	};
	'#FBD779': {
		defaultMessage: string;
		description: string;
		id: string;
	};
	'#FCB6E1': {
		defaultMessage: string;
		description: string;
		id: string;
	};
	'#FCE4A6': {
		defaultMessage: string;
		description: string;
		id: string;
	};
	'#FDD0EC': {
		defaultMessage: string;
		description: string;
		id: string;
	};
	'#FF8F73': {
		defaultMessage: string;
		description: string;
		id: string;
	};
	'#FFB8B2': {
		defaultMessage: string;
		description: string;
		id: string;
	};
	'#FFBDAD': {
		defaultMessage: string;
		description: string;
		id: string;
	};
	'#FFC400': {
		defaultMessage: string;
		description: string;
		id: string;
	};
	'#FFEBE6': {
		defaultMessage: string;
		description: string;
		id: string;
	};
	'#FFECF8': {
		defaultMessage: string;
		description: string;
		id: string;
	};
	'#FFF0B3': {
		defaultMessage: string;
		description: string;
		id: string;
	};
	'#FFF5DB': {
		defaultMessage: string;
		description: string;
		id: string;
	};
	'#FFFAE6': {
		defaultMessage: string;
		description: string;
		id: string;
	};
	'#FFFFFF': {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	'#DEEBFF': {
		id: 'fabric.theme.subtle-blue',
		defaultMessage: 'Subtle blue',
		description:
			'The text is shown as a tooltip label for a color swatch in the editor background color picker when the user hovers over the subtle blue color option.',
	},
	'#B3D4FF': {
		id: 'fabric.theme.blue',
		defaultMessage: 'Blue',
		description:
			'The text is shown as a tooltip label for a color swatch in the editor background color picker when the user hovers over the blue color option.',
	},
	'#4C9AFF': {
		id: 'fabric.theme.bold-blue',
		defaultMessage: 'Bold blue',
		description:
			'The text is shown as a tooltip label for a color swatch in the editor background color picker when the user hovers over the bold blue color option.',
	},
	'#ADCBFB': {
		id: 'fabric.theme.bold-blue-new',
		defaultMessage: 'Bold blue',
		description:
			'The text is shown as a tooltip label for a color swatch in the editor background color picker when the user hovers over the bold blue color option.',
	},
	'#E6FCFF': {
		id: 'fabric.theme.subtle-teal',
		defaultMessage: 'Subtle teal',
		description:
			'The text is shown as a tooltip label for a color swatch in the editor background color picker when the user hovers over the subtle teal color option.',
	},
	'#B3F5FF': {
		id: 'fabric.theme.teal',
		defaultMessage: 'Teal',
		description:
			'The text is shown as a tooltip label for a color swatch in the editor background color picker when the user hovers over the teal color option.',
	},
	'#79E2F2': {
		id: 'fabric.theme.bold-teal',
		defaultMessage: 'Bold teal',
		description:
			'The text is shown as a tooltip label for a color swatch in the editor background color picker when the user hovers over the bold teal color option.',
	},
	'#B1E4F7': {
		id: 'fabric.theme.bold-teal-new',
		defaultMessage: 'Bold teal',
		description:
			'The text is shown as a tooltip label for a color swatch in the editor background color picker when the user hovers over the bold teal color option.',
	},
	'#E3FCEF': {
		id: 'fabric.theme.subtle-green',
		defaultMessage: 'Subtle green',
		description:
			'The text is shown as a tooltip label for a color swatch in the editor background color picker when the user hovers over the subtle green color option.',
	},
	'#ABF5D1': {
		id: 'fabric.theme.green',
		defaultMessage: 'Green',
		description:
			'The text is shown as a tooltip label for a color swatch in the editor background color picker when the user hovers over the green color option.',
	},
	'#57D9A3': {
		id: 'fabric.theme.bold-green',
		defaultMessage: 'Bold green',
		description:
			'The text is shown as a tooltip label for a color swatch in the editor background color picker when the user hovers over the bold green color option.',
	},
	'#97EDC9': {
		id: 'fabric.theme.bold-green-new',
		defaultMessage: 'Bold green',
		description:
			'The text is shown as a tooltip label for a color swatch in the editor background color picker when the user hovers over the bold green color option.',
	},
	'#FFFAE6': {
		id: 'fabric.theme.subtle-yellow',
		defaultMessage: 'Subtle yellow',
		description:
			'The text is shown as a tooltip label for a color swatch in the editor background color picker when the user hovers over the subtle yellow color option.',
	},
	'#FFF0B3': {
		id: 'fabric.theme.yellow',
		defaultMessage: 'Yellow',
		description:
			'The text is shown as a tooltip label for a color swatch in the editor background color picker when the user hovers over the yellow color option.',
	},
	'#FFC400': {
		id: 'fabric.theme.bold-yellow',
		defaultMessage: 'Bold yellow',
		description:
			'The text is shown as a tooltip label for a color swatch in the editor background color picker when the user hovers over the bold yellow color option.',
	},
	'#EFDD4E': {
		id: 'fabric.theme.bold-yellow-new',
		defaultMessage: 'Bold yellow',
		description:
			'The text is shown as a tooltip label for a color swatch in the editor background color picker when the user hovers over the bold yellow color option.',
	},
	'#FFEBE6': {
		id: 'fabric.theme.subtle-red',
		defaultMessage: 'Subtle red',
		description:
			'The text is shown as a tooltip label for a color swatch in the editor background color picker when the user hovers over the subtle red color option.',
	},
	'#FFBDAD': {
		id: 'fabric.theme.red',
		defaultMessage: 'Red',
		description:
			'The text is shown as a tooltip label for a color swatch in the editor background color picker when the user hovers over the red color option.',
	},
	'#FF8F73': {
		id: 'fabric.theme.bold-red',
		defaultMessage: 'Bold red',
		description:
			'The text is shown as a tooltip label for a color swatch in the editor background color picker when the user hovers over the bold red color option.',
	},
	'#FFB8B2': {
		id: 'fabric.theme.bold-red-new',
		defaultMessage: 'Bold red',
		description:
			'The text is shown as a tooltip label for a color swatch in the editor background color picker when the user hovers over the bold red color option.',
	},
	'#EAE6FF': {
		id: 'fabric.theme.subtle-purple',
		defaultMessage: 'Subtle purple',
		description:
			'The text is shown as a tooltip label for a color swatch in the editor background color picker when the user hovers over the subtle purple color option.',
	},
	'#C0B6F2': {
		id: 'fabric.theme.purple',
		defaultMessage: 'Purple',
		description:
			'The text is shown as a tooltip label for a color swatch in the editor background color picker when the user hovers over the purple color option.',
	},
	'#998DD9': {
		id: 'fabric.theme.bold-purple',
		defaultMessage: 'Bold purple',
		description:
			'The text is shown as a tooltip label for a color swatch in the editor background color picker when the user hovers over the bold purple color option.',
	},
	'#E3BDFA': {
		id: 'fabric.theme.bold-purple-new',
		defaultMessage: 'Bold purple',
		description:
			'The text is shown as a tooltip label for a color swatch in the editor background color picker when the user hovers over the bold purple color option.',
	},
	'#FFFFFF': {
		id: 'fabric.theme.white',
		defaultMessage: 'White',
		description:
			'The text is shown as a tooltip label for a color swatch in the editor background color picker when the user hovers over the white color option.',
	},
	'#F4F5F7': {
		id: 'fabric.theme.gray',
		defaultMessage: 'Gray',
		description:
			'The text is shown as a tooltip label for a color swatch in the editor background color picker when the user hovers over the gray color option.',
	},
	'#B3BAC5': {
		id: 'fabric.theme.bold-gray',
		defaultMessage: 'Bold gray',
		description:
			'The text is shown as a tooltip label for a color swatch in the editor background color picker when the user hovers over the bold gray color option.',
	},
	'#B7B9BE': {
		id: 'fabric.theme.bold-gray-new',
		defaultMessage: 'Bold gray',
		description:
			'The text is shown as a tooltip label for a color swatch in the editor background color picker when the user hovers over the bold gray color option.',
	},
	'#EFFFD6': {
		id: 'fabric.theme.subtle-lime',
		defaultMessage: 'Subtle lime',
		description:
			'The text is shown as a tooltip label for a color swatch in the editor background color picker when the user hovers over the subtle lime color option.',
	},
	'#D3F1A7': {
		id: 'fabric.theme.lime',
		defaultMessage: 'Lime',
		description:
			'The text is shown as a tooltip label for a color swatch in the editor background color picker when the user hovers over the lime color option.',
	},
	'#BDE97C': {
		id: 'fabric.theme.bold-lime',
		defaultMessage: 'Bold lime',
		description:
			'The text is shown as a tooltip label for a color swatch in the editor background color picker when the user hovers over the bold lime color option.',
	},
	'#FFF5DB': {
		id: 'fabric.theme.subtle-orange',
		defaultMessage: 'Subtle orange',
		description:
			'The text is shown as a tooltip label for a color swatch in the editor background color picker when the user hovers over the subtle orange color option.',
	},
	'#FCE4A6': {
		id: 'fabric.theme.orange',
		defaultMessage: 'Orange',
		description:
			'The text is shown as a tooltip label for a color swatch in the editor background color picker when the user hovers over the orange color option.',
	},
	'#FBD779': {
		id: 'fabric.theme.bold-orange',
		defaultMessage: 'Bold orange',
		description:
			'The text is shown as a tooltip label for a color swatch in the editor background color picker when the user hovers over the bold orange color option.',
	},
	'#FFECF8': {
		id: 'fabric.theme.subtle-magenta',
		defaultMessage: 'Subtle magenta',
		description:
			'The text is shown as a tooltip label for a color swatch in the editor background color picker when the user hovers over the subtle magenta color option.',
	},
	'#FDD0EC': {
		id: 'fabric.theme.magenta',
		defaultMessage: 'Magenta',
		description:
			'The text is shown as a tooltip label for a color swatch in the editor background color picker when the user hovers over the magenta color option.',
	},
	'#FCB6E1': {
		id: 'fabric.theme.bold-magenta',
		defaultMessage: 'Bold magenta',
		description:
			'The text is shown as a tooltip label for a color swatch in the editor background color picker when the user hovers over the bold magenta color option.',
	},
});
